var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:"text-xs me-1 text--disabled "},[_vm._v(" "+_vm._s(_vm.functions.formatDate(_vm.dataCadastro, { hour: 'numeric', minute: 'numeric' }))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }